module.exports = __webpack_public_path__ + "img/resource-tech-image-04.c058e9ee.jpg";